import { Component, OnInit, Input, ViewChild, ElementRef, Inject, OnChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TreatmentModel, Treatmentlabels } from 'src/app/shared/models/treatment.model';
import { DvmpComponent } from './treatmentcycles/treatmentcycles';
import { GlobalvaribleService } from 'src/app/services/globalvarible.service';
import { DOCUMENT } from '@angular/common';
import { DvmpService } from 'src/app/shared/services/dvmp.service';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
/**
 *
 *
 * */
@Component({
  selector: 'app-treatment',
  templateUrl: './treatment.component.html',
  styleUrls: ['./treatment.component.css']
})
export class TreatmentComponent implements OnInit, OnChanges {


  @Input() patientdata;
  patient: any;
  treatmentradio = 'DVmp';
  treatmentlabels: Treatmentlabels[];
  defaultx = 1;
  @Input() name: string;
  message: String;
  @ViewChild('ipt') input: ElementRef;
  reversedropdownselection = false;
  checkflag = false;
  constructor(@Inject(DOCUMENT) private document: Document, private _dvmp: DvmpService,
    private router: Router, public _globalvarible: GlobalvaribleService) {
  }

  ngOnInit() {
    console.log('treatments file build');
    this.patient = this.patientdata;
    // ADOJ 25 start here
    // this._globalvarible.currentMessage.subscribe(message => this.message = message)
    // ADOJ 25 end here
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
  ngOnChanges() {
    this.reversedropdownselection = true;
  }
  createRange(number) {
    const items: number[] = [];
    for (let i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }


}
